export enum CRMCompanyStorm {
  NONE = 'NONE',
  PUBLIC = 'PUBLIC',
  EARLY_STAGE = 'EARLY_STAGE',
  CROSSOVER_IPO = 'CROSSOVER_IPO',
}

export const CRMCompanyStormLabels: Record<CRMCompanyStorm, string> = {
  [CRMCompanyStorm.NONE]: 'None',
  [CRMCompanyStorm.PUBLIC]: 'Public',
  [CRMCompanyStorm.EARLY_STAGE]: 'Early Stage',
  [CRMCompanyStorm.CROSSOVER_IPO]: 'Crossover/IPO',
};
